import Keycloak from 'keycloak-js';

import { getKeycloakConfig } from './keycloakConfig';

function createKeycloakInstance(): Keycloak {
	const config = getKeycloakConfig();

	return new Keycloak({
		url: config.url,
		realm: config.realm,
		clientId: config.clientId,
	});
}

let keycloakInstance: Keycloak | null = null;

function ensureKeycloakInstance(): Keycloak {
	if (!keycloakInstance) {
		keycloakInstance = createKeycloakInstance();
	}

	return keycloakInstance;
}

/** Returns the singleton `keycloak-js` instance for the configured realm/client. */
export function getKeycloak(): Keycloak {
	return ensureKeycloakInstance();
}

/**
 * Replaces the singleton Keycloak instance.
 * Required on native when processing an OAuth deep link after boot init already ran.
 */
export function resetKeycloak(): Keycloak {
	keycloakInstance = createKeycloakInstance();

	return keycloakInstance;
}

export default getKeycloak;
